import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { isEntity, isProperty } from "../../../data/utils";
import FilterCtrl from "../FilterCtrl";
import { SpatialEntity } from "../SpatialEntity";
import { IDimension, IFilter, IItem, IMeasure } from '../../../data/Query';
import { Definition, Entity } from "../../../data/Definition";
import DimensionCtrl from "../DimensionCtrl";
import MeasureCtrl from "../MeasureCtrl";


type FormProps = {
    definition: Definition,
    config: any | null,
    saveConfig: Function
};

const StatsTimeSeriesForm = ({definition, config, saveConfig}:FormProps) => {
    const configVersion = '1';

    const [dimension, setDimension] = useState<IDimension | null>(null);
    const [measure, setMeasure] = useState<IMeasure | null>(null);
    const [spatial, setSpatial] = useState<IItem | null>(null);
    const [filters, setFilters] = useState<IFilter[]>([]);
    const [isValid, setIsValid] = useState<boolean>(false);

    useEffect(() => {
        if(config) {
            initFromConfig(config);
        } 
    }, []);

    useEffect(() => {
        setIsValid(dimension != null && dimension.source.item != null && measure != null && measure.source.item != null);
    }, [dimension, measure])

    const initFromConfig = (config: any) => {
        console.log('stats time series chart > initFromConfig', config, definition);

        const { dimension, measure, spatial, filters } = config;

        //
        let d: IDimension = {
            source: {
                item: dimension && dimension.length && dimension[0].source && dimension[0].source.item ? getItemFromDefinition(dimension[0].source.item) : null,
                sub: null
            },
            bin: dimension && dimension.length ? dimension[0].bin : null
        };

        //
        let m: IMeasure = {
            source: {
                item: measure && measure.length && measure[0].source && measure[0].source.item ? getItemFromDefinition(measure[0].source.item) : null,
                sub: measure && measure.length && measure[0].source ? measure[0].source.sub : null
            },
            aggregation: measure && measure.length ? measure[0].aggregation : null
        };

        //
        let s: IItem = {
            item: spatial && spatial.item ? getItemFromDefinition(spatial.item) : null,
            sub: null
        };

        //
        let f = filters.map((filter: IFilter) : IFilter => {
            const f: IFilter = {
                source: {
                    item: filter.source && filter.source.item ? getItemFromDefinition(filter.source.item) : null,
                    sub: filter.source ? filter.source.sub : null
                },
                operation: filter.operation,
                value: filter.value
            };

            return f;
        });

        setDimension(d);
        setMeasure(m);
        setSpatial(s);
        setFilters(f);
    }

    const saveToConfig = (e: any) => {  
        e.preventDefault();

        // time dimension is derived from the measure
        // and added when the config is saved.
        const timeDimension: IDimension = {
            source: { 
                item: measure!.source.item,
                sub: 'time'
            },
            bin: "date"
        };

        let config = {
            version: configVersion,
            dimension: [dimension, timeDimension],
            measure: [measure],
            spatial: spatial,
            filters: filters 
        };

        console.log('saveToConfig', config);

        // pass back to caller.
        if(saveConfig) {
            saveConfig(config);
        }
    }

    const getItemFromDefinition = (item:any) => {   
        let defItem = item;

        // main entity.
        if(item.name === definition.name) {
            return definition as Entity;
        }

        if(isEntity(item)) {
            defItem = definition.entity.find((i:any) => {
                return i.name === item.name;
            });
        } else if(isProperty(item)) {
            defItem = definition.property.find((i:any) => {
                return i.name === item.name;
            });
        }

        return defItem;
    }

    return (
        <div>
            <div className="mt-3 p-3 bg-dark">
                <DimensionCtrl
                    definition={definition}
                    config={dimension}
                    includeRoot={true}
                    onUpdate={(d: IDimension) => setDimension(d)}>
                </DimensionCtrl>

                <MeasureCtrl
                    definition={definition}
                    measure={measure}
                    includeRoot={false}
                    propertyTypes={['stats']}
                    title="Measure (value to show over time)"
                    onUpdate={(m: IMeasure) => setMeasure(m)}>
                </MeasureCtrl>
            </div>

            <div className="mt-3 p-3 bg-dark">
                <SpatialEntity
                    definition={definition}
                    item={spatial}
                    onUpdate={(e: IItem) => setSpatial(e)}
                />

                <FilterCtrl
                    definition={definition}
                    config={filters}
                    onUpdate={(f: any) => setFilters(f)} />
            </div>
            <Button
                className="mt-3"
                variant="primary"
                type="submit"
                disabled={!isValid}
                onClick={saveToConfig}>
                Apply
            </Button>
        </div>
    );
}

export default StatsTimeSeriesForm;